<template>
  <div></div>
</template>

<script>
import { authComputed } from "@/store/helpers.js";
export default {
  mounted() {
    const checkedValue = localStorage.getItem("discordVerify");
    if (checkedValue && checkedValue === "true") {
      localStorage.removeItem("discordVerify");
      this.$router
        .push({
          name: "DeleteAccount",
          query: this.$route.query
        })
        .catch(() => {});
    } else {
      if (this.$route.query.code && !checkedValue)
        this.handleDiscordCallback(this.$route.query.code);
    }
  },
  computed: {
    ...authComputed
  },
  methods: {
    async handleDiscordCallback(token) {
      this.$store.dispatch("authorizeWithDiscord", token).then(() => {
        if (this.getAuthAction === "login") {
          this.$router.push({
            path: "/login",
            query: { singIn: "1" }
          });
        } else {
          this.$router.push({
            path: "/createAccount",
            query: { singIn: "1" }
          });
        }
      });
    }
  }
};
</script>
